function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Wechatpay = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, React) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  React = _interopRequireWildcard(React);

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

  var SvgWechatpay = function SvgWechatpay(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: props.className,
      style: props.style
    }, /*#__PURE__*/React.createElement("svg", _extends({
      viewBox: "0 0 60 40",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props), /*#__PURE__*/React.createElement("title", null, "wechatpay"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
      d: "M12.8571429,0.00285714286 C5.75571429,0.00285714286 0,4.83571429 0,10.7957143 C0.08,14.0728571 1.73428571,17.11 4.44285714,18.9557143 C4.66857143,19.1185714 4.80142857,19.3814286 4.80142857,19.6585714 C4.79857143,19.7528571 4.78428571,19.8457143 4.75714286,19.9342857 C4.54,20.7485714 4.19285714,22.0514286 4.17714286,22.1114286 C4.14142857,22.2128571 4.11714286,22.3185714 4.10857143,22.4285714 C4.10714286,22.6657143 4.29857143,22.8571429 4.53714286,22.8585714 C4.62571429,22.8557143 4.71,22.8285714 4.78428571,22.78 L7.59857143,21.1428571 C7.80571429,21.0142857 8.04,20.9471429 8.28142857,20.9414286 C8.40857143,20.9414286 8.53857143,20.9628571 8.66,21 C10.0242857,21.3928571 11.4371429,21.5928571 12.8571429,21.5928571 C19.9571429,21.5928571 25.7142857,16.7585714 25.7142857,10.7957143 C25.7071429,9.02428571 25.2,7.29142857 24.25,5.79428571 L9.44571429,14.4071429 L9.35142857,14.46 C9.23142857,14.5214286 9.1,14.5542857 8.96571429,14.5542857 C8.65428571,14.5528571 8.36857143,14.3842857 8.21714286,14.1114286 L8.16285714,13.9871429 L5.82142857,8.81285714 C5.79571429,8.75571429 5.78142857,8.69428571 5.78,8.63142857 C5.77857143,8.39428571 5.96857143,8.20142857 6.20571429,8.19857143 C6.3,8.19857143 6.39142857,8.22857143 6.46571429,8.28571429 L9.22714286,10.2671429 C9.56571429,10.4914286 9.99,10.54 10.3685714,10.3985714 L23.36,4.57285714 C20.7571429,1.66142857 17.0385714,0 13.1428571,0 C13.0485714,0 12.9514286,0 12.8571429,0.00285714286 Z",
      id: "path-1"
    })), /*#__PURE__*/React.createElement("g", {
      id: "wechatpay",
      stroke: "none",
      strokeWidth: 1,
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("rect", {
      fill: "#F3F6F9",
      x: 0,
      y: 0,
      width: 60,
      height: 40
    }), /*#__PURE__*/React.createElement("g", {
      id: "Group-5"
    }, /*#__PURE__*/React.createElement("polygon", {
      id: "Fill-1",
      fill: "#16AA16",
      points: "0 39.9998571 60 39.9998571 60 0 0 0"
    }), /*#__PURE__*/React.createElement("g", {
      id: "Group-4",
      transform: "translate(17.714286, 8.931571)"
    }, /*#__PURE__*/React.createElement("mask", {
      id: "mask-2",
      fill: "white"
    }, /*#__PURE__*/React.createElement("use", {
      xlinkHref: "#path-1"
    })), /*#__PURE__*/React.createElement("g", {
      id: "Clip-3"
    }), /*#__PURE__*/React.createElement("polygon", {
      id: "Fill-2",
      fill: "#FFFFFF",
      mask: "url(#mask-2)",
      points: "-8.08571429 29.74 31.9142857 29.74 31.9142857 -7.40285714 -8.08571429 -7.40285714"
    }))))));
  };

  var _default = SvgWechatpay;
  _exports["default"] = _default;
});